"use strict";
/**
 * @file 交通路况图层
 * @author hedongran [hdr01@126.com]
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Map_1 = require("../Map/Map");
var common_1 = require("../common");
;
/**
 * 该组件用于展示交通路况的矢量图层
 * @visibleName TrafficLayer 交通路况图层
 */
var TrafficLayer = /** @class */ (function (_super) {
    tslib_1.__extends(TrafficLayer, _super);
    function TrafficLayer(props) {
        var _this = _super.call(this, props) || this;
        _this._showLayer = false;
        return _this;
    }
    TrafficLayer.prototype.componentDidMount = function () {
        this.initialize();
    };
    TrafficLayer.prototype.componentDidUpdate = function (prevProps) {
        this.initialize();
    };
    TrafficLayer.prototype.componentWillUnmount = function () {
        if (this._showLayer && this.map && !this.map._destroyed) {
            this.map.setTrafficOff();
            this._showLayer = false;
        }
    };
    TrafficLayer.prototype.initialize = function () {
        var map = this.map = this.getMap();
        if (!map) {
            return;
        }
        if (!this._showLayer) {
            map.setTrafficOn();
            this._showLayer = true;
        }
    };
    TrafficLayer.prototype.render = function () {
        return null;
    };
    TrafficLayer.contextType = Map_1.MapContext;
    return TrafficLayer;
}(common_1.Component));
exports.default = TrafficLayer;
